export default [
  {
    title: 'Studenterjob: Interesserer du dig for salg og marketing?',
    description:
      'Vi er et ungt og ambitiøst firma med stærke kompetencer inden for digitale kommunikationsløsninger. Vores kerneprodukt hedder Ekko App. Ekko app er en brugervenlig app til kompleks intern kommunikation, der skaber arbejdsglæde og gør kommunikationen mellem virksomheder og deres medarbejdere effektiv, tidsbesparende og sjov.',
    theHubLink: 'https://thehub.io/jobs/5e32ebda269ebc1d9eb0ee1c',
  },
]
